import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UserComponent } from './user.component';
import { UserGridComponent } from './user-grid/user-grid.component';
import { ManageSettingsComponent } from './manage-settings/manage-settings.component';
import { UserAvailabilityComponent } from './user-availability/user-availability.component';
import { UnSavedChangesRouteGuard } from 'src/app/shared/routeguards/unsavedChangesRouteGuard';
import {UserSettingsComponent} from './user-settings/user-settings.component';

import { UserSkillsComponent } from './user-skills/user-skills.component';

const routes: Routes = [{ path: '', component: UserGridComponent },

{ path: 'user-settings', component: ManageSettingsComponent ,canDeactivate: [UnSavedChangesRouteGuard]},
{ path: 'user-skills', component: UserSkillsComponent },
{path: '', component: UserGridComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
